import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  zoom:"",
  bounds :"",
  center :"",
};

const mapZAB = createSlice({
  name: "mapstateZAB",
  initialState,
  reducers: {
    setMapZABState: (state, action) => {
      state.zoom = action.payload.zoom;
      state.bounds = action.payload.bounds;
      state.center = action.payload.center;
    },
  },
});

export const { setMapZABState } = mapZAB.actions;
export const selectMapZABstate = (state) => state.mapstateZAB;

export default mapZAB.reducer;
